export class ExpertBankAccount {
  constructor(json) {
    // this.id = json?.id ?? ""
    this.orgName = json?.orgName ?? ""
    this.bank = json?.bank ?? ""
    this.bill = json?.bill ?? ""
    this.inn = json?.inn ?? ""
    this.kpp = json?.kpp ?? ""
    this.address = json?.address ?? ""
    this.bankBik = json?.bankBik ?? ""
    this.bankKpp = json?.bankKpp ?? ""
    this.bankInn = json?.bankInn ?? ""
    this.bankBill = json?.bankBill ?? ""
    this.bankAddress = json?.bankAddress ?? ""

    this.bankCorrBill = json?.bankCorrBill ?? ""
    this.kbk = json?.kbk ?? ""
    this.oktmo = json?.oktmo ?? ""
    this.createdDate = json?.createdDate ?? ""
    this.modifiedDate = json?.modifiedDate ?? ""
  }
}